import { render, staticRenderFns } from "./InputSelectMultipleNovo.vue?vue&type=template&id=99ba526c&"
import script from "./InputSelectMultipleNovo.vue?vue&type=script&lang=js&"
export * from "./InputSelectMultipleNovo.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./InputSelectMultipleNovo.vue?vue&type=style&index=1&id=99ba526c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports